import { render, staticRenderFns } from "./ThayDongHoDien.vue?vue&type=template&id=0b9ee54d"
import script from "./ThayDongHoDien.vue?vue&type=script&lang=js"
export * from "./ThayDongHoDien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports